module.exports = __webpack_public_path__ + "static/media/ic_kyc_complete.6326aaf0.svg";